import {
  BankAccountStoreState,
  PaymentProviderBankDetails,
  VerificationStatuses
} from '@/interfaces/bank-account';

export function hasBankDetails(state: BankAccountStoreState): boolean {
  return Object.keys(state.bank_details).length > 0;
}

export function getBankDetails(state: BankAccountStoreState): PaymentProviderBankDetails {
  return state.bank_details;
}

export function getBankAccountLastFour(state: BankAccountStoreState): string {
  return state.bank_details.bank_account_last_4;
}

export function getBankAccountStatus(state: BankAccountStoreState): VerificationStatuses {
  return state.bank_details.bank_status;
}
